import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { UiBenefitBadgeAtomComponent, UiBenefitBadgeLayout } from '../../atoms/ui-benefit-badge/ui-benefit-badge.component';

@Component({
  selector: 'app-offer-info-molecule',
  imports: [UiBenefitBadgeAtomComponent],
  host: {
    '[class.offer-info-summary]': "layout() === 'summary'",
  },
  template: `
    <div class="offer-info__main">
      @if (mainLabel()) {
        <p class="offer-info__label">{{ mainLabel() }}</p>
      }
      <p class="offer-info__value"
        [class.is-expanded]="isExpanded"
        (click)="isExpanded = !isExpanded"
        ><span class="offer-info__value-prefix">{{ receiveValueParts().prefix }}</span><span class="offer-info__value-amount">{{ receiveValueParts().amount }}</span>
        </p>
    </div>
    <div class="offer-info__details">
      @if (detail1Title() && detail1Value()) {
        <div class="offer-info__detail-col">
          <p class="offer-info__label">{{ detail1Title() }}:</p>
          <p class="offer-info__value">
            @for (seg of splitKeywordSegments(detail1Value()); track $index) {
              <span [class.offer-info__value-prefix]="!seg.bold" [class.offer-info__value-amount]="seg.bold">{{ seg.text }}</span>
            }
          </p>
        </div>
      }
      @if (approxTitle() || captionValue()) {
        <div class="offer-info__detail-col">
          <p class="offer-info__label">{{ approxTitle() ? approxTitle() + ':' : '' }}</p>
          <p class="offer-info__value"
          [class.is-expanded]="captionValueExpanded"
          (click)="captionValueExpanded = !captionValueExpanded"
          >
            @for (seg of splitKeywordSegments(captionValue()); track $index) {
              <span [class.offer-info__value-prefix]="!seg.bold" [class.offer-info__value-amount]="seg.bold">{{ seg.text }}</span>
            }
          </p>
        </div>
      }
    </div>
    @if (additionalBenefits()) {
      <app-ui-benefit-badge [layout]="benefitBadgeLayout()" [showCrown]="showCrown()" [text]="benefitsText()" />
    }
  `,
  styleUrl: './offer-info-molecule.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferInfoMoleculeComponent {
  captionValueExpanded = false;

  isExpanded = false;
  readonly mainLabel = input('Recibes:');
  readonly layout = input<'default' | 'summary'>('default');
  readonly receiveValue = input.required<string>();
  readonly captionValue = input('');

  // Todo lo que viene desde el signo "$" en adelante se resalta en negrilla (p.ej. "Hasta $1.500.000").
  readonly receiveValueParts = computed(() => {
    const value = this.receiveValue();
    const dollarIndex = value.indexOf('$');
    if (dollarIndex === -1) {
      return { prefix: value, amount: '' };
    }
    return { prefix: value.slice(0, dollarIndex), amount: value.slice(dollarIndex) };
  });

  readonly detail1Title = input<string | undefined>(undefined);
  readonly detail1Value = input<string | undefined>(undefined);

  readonly approxTitle = input('');

  // Palabras conectoras (Desde/Hasta/De) quedan en peso normal; el resto del texto en negrilla.
  protected splitKeywordSegments(value: string | null | undefined): Array<{ text: string; bold: boolean }> {
    if (!value) {
      return [];
    }
    // Se pueden agregar más palabras sin negrilla si es necesario.
    const regex = /(Desde|Hasta|De)\b/gi;
    const segments: Array<{ text: string; bold: boolean }> = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    while ((match = regex.exec(value)) !== null) {
      if (match.index > lastIndex) {
        segments.push({ text: value.slice(lastIndex, match.index), bold: true });
      }
      segments.push({ text: match[0], bold: false });
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < value.length) {
      segments.push({ text: value.slice(lastIndex), bold: true });
    }
    return segments;
  }

  readonly additionalBenefits = input(false);
  readonly benefitsText = input('');
  readonly benefitBadgeLayout = input<UiBenefitBadgeLayout>('default');
  readonly showCrown = input(true);
}
